import { Headphones, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function Audiobooks() {
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16 fade-in">
      <div className="label-eyebrow text-accent mb-3">Livres audio</div>
      <h1 className="font-serif text-5xl md:text-6xl tracking-tight">Écoutez, laissez-vous porter.</h1>
      <p className="mt-6 text-muted-foreground text-lg max-w-2xl leading-relaxed">
        Les livres audio de Baron Vincent de Paul arrivent très bientôt. Streaming, téléchargement, aperçus — inscrivez-vous à la newsletter pour être alerté du lancement.
      </p>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { title: "Streaming HD", desc: "Écoutez sans limites depuis n'importe quel appareil." },
          { title: "Téléchargement", desc: "Emportez vos livres partout, même hors ligne." },
          { title: "Aperçus gratuits", desc: "Écoutez les premières minutes avant d'acheter." },
        ].map((f) => (
          <div key={f.title} className="p-8 border border-border">
            <Headphones className="w-6 h-6 text-accent" />
            <h3 className="mt-4 font-serif text-xl">{f.title}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{f.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-20 p-12 border border-border bg-secondary/40 text-center">
        <Play className="w-8 h-8 text-accent mx-auto" />
        <h2 className="mt-6 font-serif text-3xl">Bientôt disponible</h2>
        <p className="mt-3 text-muted-foreground max-w-xl mx-auto">
          Nous préparons soigneusement chaque enregistrement. En attendant, découvrez les livres numériques.
        </p>
        <Link to="/catalogue"><Button data-testid="audiobook-catalog-btn" className="mt-8 rounded-sm">Voir le catalogue</Button></Link>
      </div>
    </div>
  );
}
